import React from "react";
import { Link } from "react-router-dom";
import { ORG, SOCIALS } from "../data/site";
import { PHOTO_CREDIT } from "../data/photos";
import { Mark, Pin, Phone, Mail, Social } from "./icons";

function Footer() {
  return (
    <footer className="site-foot">
      <div className="wrap foot-grid">
        <div className="foot-brand">
          <Link className="brand" to="/" aria-label="EMANAC home">
            <Mark />
            <b>EMANAC</b>
          </Link>
          <p className="foot-exp">{ORG.expansion}</p>
          <p className="foot-motto">{ORG.motto}</p>
          <ul className="socials">
            {SOCIALS.map((s) => (
              <li key={s.label}>
                <a href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`EMANAC on ${s.label}`}>
                  <Social name={s.label} />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <nav className="foot-col" aria-label="Explore">
          <h2>Explore</h2>
          <Link to="/">Home</Link>
          <Link to="/about">About us</Link>
          <Link to="/services">Services</Link>
          <Link to="/blog">Blog</Link>
        </nav>

        <nav className="foot-col" aria-label="Get involved">
          <h2>Get involved</h2>
          <Link to="/joinUs">Join the community</Link>
          <Link to="/services#training">Training programmes</Link>
          <Link to="/services#solutions">Hire our team</Link>
          <Link to="/contact">Contact us</Link>
        </nav>

        <div className="foot-col">
          <h2>Reach us</h2>
          <p className="foot-line"><Pin />{ORG.address}</p>
          <a className="foot-line" href={ORG.phoneHref}><Phone />{ORG.phone}</a>
          <a className="foot-line" href={`mailto:${ORG.email}`}><Mail />{ORG.email}</a>
        </div>
      </div>

      <div className="wrap foot-base">
        <p>© {new Date().getFullYear()} EMANAC. All rights reserved.</p>
        <p>
          Photography by <a href={PHOTO_CREDIT.href} target="_blank" rel="noopener noreferrer">{PHOTO_CREDIT.name}</a>,
          {" "}{PHOTO_CREDIT.place}. The photos show the communities we serve.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
